/**
 * Numérotation des sections d'un CR dans l'aperçu « Sections du compte rendu » (sections par CR,
 * plan 2026-10-27). Jumeau JS de la règle que le serveur rend au premier affichage :
 * `MeetingReports::SectionLayout#number_for` (numéros) et `StructureModalComponent#preview_lines`
 * (n° de page de l'aperçu). Le serveur reste la source (verdict DS 6) ; ce module ne fait que
 * recalculer la même chose quand un interrupteur change.
 *
 * Parité verrouillée par `test/components/meeting_reports/structure_preview_js_parity_test.rb`, qui
 * lance `test/javascript/support/cr_section_layout_runner.mjs` sur TOUTES les combinaisons de
 * sections masquables et compare à la sortie Ruby : une règle modifiée d'un seul côté rougit.
 *
 * Règle :
 *   - visible = verrouillée (Remarques, Prochaine réunion : P4) OU cochée ;
 *   - numéro = rang parmi les visibles NON `unnumbered` (Annexes, P15), à partir de 1 ; `null` sinon ;
 *   - page = `firstPage + floor(i / linesPerPage)`, `i` = rang parmi TOUTES les visibles (Annexes
 *     comprises) ; `null` pour une masquée.
 *
 * @param {{ slug: string, visible: boolean, unnumbered: boolean }[]} rows dans l'ordre du sommaire
 * @param {{ firstPage: number, linesPerPage: number }} options
 * @returns {{ slug: string, visible: boolean, number: number | null, page: number | null }[]}
 */
export function crSectionLayout(rows, { firstPage, linesPerPage }) {
  const perPage = Math.max(1, Math.trunc(linesPerPage) || 1);
  let numbered = 0;
  let lineIndex = 0;
  return rows.map(({ slug, visible, unnumbered }) => {
    if (!visible) return { slug, visible: false, number: null, page: null };

    const number = unnumbered ? null : (numbered += 1);
    const page = firstPage + Math.floor(lineIndex / perPage);
    lineIndex += 1;
    return { slug, visible: true, number, page };
  });
}
